module.exports = __webpack_public_path__ + "59466b176a168a6f2cb7fd8240437ffa.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/wangshaohong_qrcode.png
// module id = 86
// module chunks = 1